'use client';

import { STATS } from '@/lib/constants';
import { Card, CardContent } from '@/components/ui/card';

export function Stats() {

  return (
    <section className="py-12 bg-background">
      <div className="container mx-auto px-4">
        <div 
          className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center"
        >
          {STATS.map((stat) => (
            <div key={stat.label}>
                <Card className="shadow-lg border-2 border-primary/20 h-full">
                <CardContent className="p-6">
                    <p className="text-4xl lg:text-5xl font-extrabold text-primary font-headline">
                    {stat.value}
                    </p>
                    <p className="mt-2 text-lg font-medium text-muted-foreground">
                    {stat.label}
                    </p>
                </CardContent>
                </Card>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
